module.exports = __webpack_public_path__ + "img/icon_foot_packup.bbda55a9.png";